import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import DefaultImage from 'assets/images/campaign/default_campaign_image_400x400.png'
import hexToRgb from 'functions/hexToRgb'

import styles from './styles.scss'

class Comparable extends Component {
  _renderBanner = () => {
    const {
      campaignComparable: { sold },
      brand: { colour_secondary, colour_highlight },
    } = this.props
    const backgroundColor = colour_secondary || null
    const fontColor = colour_highlight || null

    return sold ? (
      <span className={styles.banner} style={{ backgroundColor: `#${backgroundColor}`, color: `#${fontColor}` }}>
        SOLD
      </span>
    ) : null
  }

  render(){
    const {
      campaignComparable: {
        address,
        suburb_name,
        bedrooms,
        bathrooms,
        carparks,
        sale_type,
        price_guide,
        default_image,
      },
      large,
      brand: { colour_primary, colour_highlight },
    } = this.props

    const overlayBackgroundColor = hexToRgb(colour_primary)
    const overlayFontColor = colour_highlight ? `#${colour_highlight}` : null

    return (
      <article className={large ? classnames(styles.root, styles.large) : styles.root}>
        <span
          className={styles.image}
          style={{ backgroundImage: default_image ? `url(${default_image})` : `url(${DefaultImage})` }}
        >
          <div
            className={styles.overlay}
            style={{
              background: `rgba(${overlayBackgroundColor.r},${overlayBackgroundColor.g}, ${
                overlayBackgroundColor.b
              }, 0.7)`,
              color: `${overlayFontColor}`,
            }}
          >
            <span className={styles.saleMethod}>{sale_type}</span>
            <span className={styles.price}>{price_guide}</span>
          </div>
          {this._renderBanner()}
        </span>
        <div className={styles.details}>
          <span className={styles.address}>{address}</span>
          <span className={styles.suburb}>{suburb_name}</span>
          <span className={styles.features}>
            {bedrooms && `${bedrooms} Bed | `}
            {bathrooms && `${bathrooms} Bath | `}
            {carparks && `${carparks} Car`}
          </span>
        </div>
      </article>
    )
  }
}

Comparable.propTypes = {
  brand: PropTypes.object.isRequired,
  campaignComparable: PropTypes.object.isRequired,
  large: PropTypes.bool,
}

Comparable.defaultProps = {
  large: false,
}

export default Comparable
